import LegendButton from './LegendButton';

export default LegendButton;
